import React, { useState } from 'react';
import FeatureTabs, { CarouselControls } from '../utils/FeatureTab';
import { analyticsData, analyticsTabFeature } from '../utils/constant';
import {
  CTABanner,
  SuperChargeCard,
  ToolsCard,
} from '../components/ui/UtilsLayout';
import SignupModal from '../components/SignupModal';

export default function Analytics() {
  const [activeFeatureIndex, setActiveFeatureIndex] = useState(0);
  const [showSignupModal, setShowSignupModal] = useState(false);

  return (
    <div className="bg-[#121316] flex flex-col">
      {/* HERO SECTION */}
      <section className="relative px-8 pt-28 md:pt-40 w-full max-w-[1500px] mx-auto">
        <div className="text-center space-y-6">
          <h1 className="text-2xl md:text-4xl font-bold text-[#D8D8D8] tracking-tight">
            Spatial Intelligence for Every XR Experience
          </h1>
          <p className="text-[20px] md:text-[24px] text-[#717173] max-w-3xl mx-auto font-medium">
            Real-Time Metrics, Behavior Insights, and Operational Visibility
            Across AR, VR, and MR
          </p>
        </div>

        {/* VIDEO SECTION */}
        <div className=" mt-5 md:mt-16 max-w-[1200px] w-full mx-auto">
          {/* Buttons - mobile only, left aligned, ABOVE video */}
          <div className="flex md:hidden mb-3 justify-end">
            <CarouselControls
              activeIndex={activeFeatureIndex}
              total={analyticsTabFeature.length}
              onChange={setActiveFeatureIndex}
            />
          </div>
          <div className="w-full flex items-center justify-center aspect-[16/9] bg-[#1A1C20] rounded-[10px] border border-gray-800 overflow-hidden">
            {analyticsTabFeature[activeFeatureIndex]?.video ? (
              <video
                key={analyticsTabFeature[activeFeatureIndex].video}
                className="w-full h-full object-cover"
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
              >
                <source
                  src={analyticsTabFeature[activeFeatureIndex].video}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            ) : (
              <div className="text-gray-500">No video available</div>
            )}
          </div>
        </div>
      </section>

      {/* FEATURE TABS SECTION */}
      <section className=" pb-5 md:pb-10 w-full max-w-[1260px] mx-auto px-8 lg:px-8">
        <FeatureTabs
          title="Core Multiplayer Features"
          desc="Key functionality that enables real-time collaboration in shared mixed realities."
          features={analyticsTabFeature}
          showImage={false}
          gridCols="md:grid-cols-3"
          activeIndex={activeFeatureIndex}
          onTabChange={setActiveFeatureIndex}
        />
      </section>

      {/* MAIN FEATURES GRID */}
      <section className="px-8 w-full max-w-[1500px] mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 text-[#D8D8D8] font-jakarta">
            See the Grid. Understand the Experience.
          </h2>
          <p className="text-[#717173] max-w-4xl mx-auto text-[18px] md:text-[24px] font-medium">
            Actionable Analytics Structured Through a Spatial Grid System
          </p>
        </div>

        <div className="w-full grid  xl:px-[8%] grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-2 md:gap-4 my-7 lg:gap-10">
          {analyticsData.map((feature, index) => (
            <SuperChargeCard
              key={index}
              img={feature.img}
              title={feature.title}
              desc={feature.description}
            />
          ))}
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20 max-w-[1300px]">
        <CTABanner
          welcomeText="Turn spatial behavior into actionable insights."
          description="Transform spatial behavior into meaningful insights with Spatial Grid Analytics. Track engagement, performance, and interaction patterns to improve every experience."
          buttonText="Get Started"
          onButtonClick={() => setShowSignupModal(true)}
        />
      </section>

      {/* Signup Modal Component */}
      <SignupModal
        isOpen={showSignupModal}
        onClose={() => setShowSignupModal(false)}
      />
    </div>
  );
}
